export const ResourceNames = {
  Resources: "Resources",
  PrevScheda: "PrevScheda",
  MenuItems: "MenuItems",
  Forms: "Forms",
  FormFieldsList: "FormFieldsList",
  ResourcesViewes: "ResourcesViewes",
  MenuItemsGridCustomActions: "MenuItemsGridCustomActions",
  UserCompanies: "UserCompanies",
  Dipendenti: "Dipendenti",
  ProdLookupDipendenti: "ProdLookupDipendenti",
  Commesse: "Commesse",
  PrevAccessori: "PrevAccessori",
  PrevCosti: "PrevCosti",
  PrevRicavi: "PrevRicavi",
  PrevTipiAccessori: "PrevTipiAccessori",
  PrevTipiCosti: "PrevTipiCosti",
  PrevTipiRicavi: "PrevTipiRicavi",
  ProdFasi: "ProdFasi",
  UnitaMisura: "UnitaMisura",
  ArticoliConfezioni: "ArticoliConfezioni",
  ResourcesFields: "ResourcesFields",
  ProdSessioniLavoro: "ProdSessioniLavoro",
  ProdVersamentoSpese: "ProdVersamentoSpese",
  ProdSpese: "ProdSpese",
  ProdVersamentoTempi: "ProdVersamentoTempi",
  ProdSessioniLavoroMovimenti: "ProdSessioniLavoroMovimenti",
  PrevModelli: "PrevModelli",
  PrevRichieste: "PrevRichieste",
  PrevListiniLavRead: "PrevListiniLavRead",
  PrevRichiesteRighe: "PrevRichiesteRighe",
  PrevSchedaProdotti: "PrevSchedaProdotti",
  PrevSchedaMateriali: "PrevSchedaMateriali",
  PrevSchedaLavorazioni: "PrevSchedaLavorazioni",
  PrevCostoMaterialiRead: "PrevCostoMaterialiRead",
  PrevCostoAccessoriRead: "PrevCostoAccessoriRead",
  PrevSchedaCostiAggiuntivi: "PrevSchedaCostiAggiuntivi",
  PrevSchedaRicavi: "PrevSchedaRicavi",
  PrevSchedaAccessori: "PrevSchedaAccessori",
  ATAS_SchedaPreventivo: "ATAS_SchedaPreventivo",
  Articoli: "Articoli",
  ResourcesJumps: "ResourcesJumps",
  AspNetUsers: "AspNetUsers",
  AutomezziAziendali: "AutomezziAziendali",
  TeVeParametriPiazzista: "TeVeParametriPiazzista",
  LicensePacks: "LicensePacks",
  LicenseSerials: "LicenseSerials",
  Agenti: "Agenti",
  UserProfile: "UserProfile",
  MagautoDocumentiInviati: "MagautoDocumentiInviati",
  ResourcesViewsLinks: "ResourcesViewsLinks",
  ResourcesViewsFields: "ResourcesViewsFields",
  ResourcesViewsFilters: "ResourcesViewsFilters",
  ResourcesViewsSortFields: "ResourcesViewsSortFields",
  Companies: "Companies",
  FormsGroups: "FormsGroups",
  FormsFields: "FormsFields",
  GetExternalInfo: "GetExternalInfo",
  ResourcesLookups: "ResourcesLookups",
  CompanyUsers: "CompanyUsers",
  UserProducts: "UserProducts",
  UserForms: "UserForms",
  CompanyForms: "CompanyForms",
  StandardForms: "StandardForms",
  PrevMateriali: "PrevMateriali",
  WebSocketClients: "WebSocketClients",
  LogisticaUbicazioni: "LogisticaUbicazioni",
  LogisticaSitUbi: "LogisticaSitUbi",
  DataExchangeJobs: "DataExchangeJobs",
  DataExchangeDevices: "DataExchangeDevices",
  DataExchangeJobsDevices: "DataExchangeJobsDevices",
  DataExchangePlugins: "DataExchangePlugins",
  PrevSitMargine: "PrevSitMargine",
  DataExchangePluginDevices: "DataExchangePluginDevices",
  DataExchangeJobsTranscodes: "DataExchangeJobsTranscodes",
  CompaniesAgents: "CompaniesAgents",
  ProformaClientSessionsLogs: "ProformaClientSessionsLogs",
};
